import { FETCH_ORDER_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const orderListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORDER_LIST:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default orderListReducer;
